// Which parts of the student app an institute exposes.
//
// Mirrors the server's defaults so the settings page can render sensible
// toggles for an institute that has never saved a feature map.

export const FEATURE_KEYS = [
  'assignedTests',
  'practiceTests',
  'learningCenter',
  'analytics',
  'chatbot',
  'teachMe',
];

export const DEFAULT_FEATURES = {
  assignedTests: true,
  practiceTests: true,
  learningCenter: true,
  analytics: true,
  chatbot: false,
  teachMe: false,
};

/** Features that students can be given or denied. Assigned tests are not one. */
export const EDITABLE_FEATURES = [
  {
    key: 'practiceTests',
    label: 'Practice tests',
    description: 'Students can practise on their own from the exam question bank.',
  },
  {
    key: 'learningCenter',
    label: 'Learning centre',
    description: 'Topic lessons and notes, including any notes you publish.',
  },
  {
    key: 'analytics',
    label: 'Progress and analytics',
    description: 'Students can see their own strengths and weak areas.',
  },
  {
    key: 'chatbot',
    label: 'AI assistant',
    description: 'Students can ask questions and get explanations. Uses AI credits.',
  },
  {
    key: 'teachMe',
    label: 'AI video lessons',
    description: 'Students can generate their own lessons. Uses AI credits.',
  },
];

/**
 * An organization's feature map with defaults applied.
 *
 * Assigned tests are forced on: they are the reason the student experience
 * exists, and the server enforces the same rule.
 */
export function resolveFeatures(org) {
  const stored = org?.features;
  const resolved = { ...DEFAULT_FEATURES };

  if (stored && typeof stored === 'object') {
    FEATURE_KEYS.forEach((key) => {
      if (key in stored) resolved[key] = Boolean(stored[key]);
    });
  }

  resolved.assignedTests = true;
  return resolved;
}
